import { createIcon, Icon } from "@chakra-ui/icon"

export const LikeIcon = createIcon({
	displayName: "LikeIcon",
	viewBox: "0 0 15 15",
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15 7.5C15 6.23814 14.1522 5.25 12.75 5.25H10.4452L10.4661 5.1932C10.4869 5.13696 10.5454 4.98272 10.6023 4.83267L10.6027 4.83172L10.6027 4.83167C10.6532 4.69855 10.7024 4.56893 10.7228 4.51418C10.8654 4.13142 10.9695 3.82302 11.0537 3.5176C11.1809 3.05598 11.25 2.64008 11.25 2.25C11.25 1.146 10.5689 0.460289 9.56121 0.166865C9.10671 0.0345213 8.7111 -6.87334e-05 8.25 1.02474e-07H7.89037L7.6652 0.280414C7.41085 0.597168 6.91128 1.16803 6.33532 1.82618L6.33529 1.82621L6.33526 1.82625C5.27269 3.04044 3.95016 4.55169 3.42776 5.31256C3.2922 5.2723 3.14862 5.25069 3 5.25069H1.5C0.671573 5.25069 0 5.92226 0 6.75069V13.5007C0 14.3291 0.671573 15.0007 1.5 15.0007H3C3.51535 15.0007 3.96999 14.7408 4.24003 14.3449C4.46756 14.4921 4.72142 14.6149 4.99734 14.7136C5.62908 14.9397 6.25564 15.0091 6.7758 14.9996L12 15C14.0664 15 15 11.9577 15 7.5ZM5.50266 13.3013C4.83897 13.0639 4.5 12.6767 4.5 12V6.75069V6.75001C4.5 6.56986 4.53332 6.41034 4.60628 6.23999C4.73734 5.934 5.92645 4.57736 7.0535 3.29151L7.05351 3.29151L7.05354 3.29147C7.63521 2.62785 8.20035 1.98309 8.59497 1.51135C8.78354 1.5255 8.96128 1.55448 9.14185 1.60706C9.57163 1.7322 9.75 1.91177 9.75 2.25C9.75 2.48744 9.70195 2.77674 9.60761 3.11896C9.53711 3.37469 9.44581 3.64528 9.31719 3.9905C9.299 4.03934 9.25368 4.15878 9.20542 4.28597L9.20498 4.28715C9.14595 4.44272 9.08264 4.60959 9.05922 4.67292C8.96169 4.93663 8.89744 5.1308 8.85349 5.30724C8.66665 6.05727 8.85409 6.75001 9.75 6.75001H12.75C13.2684 6.75001 13.5 7.01992 13.5 7.50001C13.5 11.0931 12.7613 13.5 12 13.5H6.75L6.7223 13.5005C6.39403 13.5063 5.93297 13.4553 5.50266 13.3013ZM1.5 13.5007V6.75067H3V13.5007H1.5Z"
		/>
	),
})
export const HeartIcon = createIcon({
	displayName: "HeartIcon",
	viewBox: "0 0 17 16",
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.0184 0.085187C10.8997 0.0851746 10.1787 0.218442 9.35205 0.623049C9.04601 0.772848 8.75889 0.95325 8.49225 1.16372C8.23588 0.965049 7.96023 0.79293 7.66685 0.647824C6.8242 0.231046 6.06612 0.0851746 4.9876 0.0851746C2.09906 0.0851746 0 2.47852 0 5.5869C0 7.93435 1.30887 10.2019 3.74683 12.3946C5.02651 13.5456 6.66039 14.6846 7.83051 15.2905L8.5 15.6372L9.16949 15.2905C10.3396 14.6846 11.9735 13.5456 13.2532 12.3946C15.6911 10.2019 17 7.93435 17 5.5869C17 2.51142 14.8811 0.0970424 12.0184 0.085187ZM15.4546 5.58691C15.4546 7.42602 14.3621 9.31876 12.2197 11.2456C11.0517 12.2961 9.55012 13.3459 8.50002 13.8967C7.44991 13.3459 5.94833 12.2961 4.78032 11.2456C2.63797 9.31876 1.54547 7.42602 1.54547 5.58691C1.54547 3.29025 3.00101 1.63065 4.98762 1.63065C5.84514 1.63065 6.37357 1.73233 6.98171 2.03312C7.34093 2.21079 7.65842 2.44539 7.93325 2.73856L8.50182 3.3451L9.06523 2.73375C9.34623 2.42884 9.66839 2.18889 10.0315 2.01116C10.6218 1.72221 11.1172 1.63065 12.0152 1.63065C13.9773 1.63878 15.4546 3.32212 15.4546 5.58691Z"
		/>
	),
})
export const BulbIcon = createIcon({
	displayName: "BulbIcon",
	viewBox: "0 0 13 18",
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.98574 12.6974V14.5143C9.98574 16.4394 8.42513 18 6.50002 18C4.57492 18 3.01431 16.4394 3.01431 14.5143V12.6974C3.01431 12.5272 2.95403 12.3415 2.81167 12.0971C2.7202 11.9401 2.60054 11.7676 2.42 11.5287L2.35922 11.4494L2.35919 11.4494C2.2386 11.2922 1.97541 10.9492 1.87823 10.8179C0.893638 9.48809 0.400024 8.3009 0.400024 6.67144C0.400024 3.3025 3.13109 0.571442 6.50002 0.571442C9.86896 0.571442 12.6 3.3025 12.6 6.67144C12.6 8.33653 12.0997 9.56879 11.1235 10.8961C11.02 11.0368 10.759 11.376 10.6044 11.5769C10.5439 11.6555 10.4997 11.713 10.4876 11.7291C10.2903 11.9915 10.1678 12.1776 10.0881 12.3391C10.016 12.4853 9.98574 12.5983 9.98574 12.6974ZM8.28096 12.2829C8.32541 12.0418 8.40806 11.8053 8.52509 11.5681C8.66265 11.2892 8.83758 11.0236 9.09442 10.6819C9.11205 10.6584 9.16886 10.5846 9.24224 10.4892L9.24236 10.489C9.39928 10.285 9.63193 9.9825 9.71945 9.8635C10.4938 8.81061 10.8572 7.91576 10.8572 6.67144C10.8572 4.26506 8.90642 2.3143 6.50003 2.3143C4.09365 2.3143 2.14289 4.26506 2.14289 6.67144C2.14289 7.87275 2.49727 8.72506 3.27897 9.78088C3.36284 9.89416 3.59959 10.2028 3.72765 10.3698L3.72788 10.3701L3.81035 10.4778C4.02931 10.7675 4.18421 10.9908 4.31769 11.2199C4.52557 11.5768 4.66358 11.9247 4.72336 12.2854C5.2664 12.6114 5.85343 12.7715 6.50004 12.7715C7.14833 12.7715 7.73674 12.6105 8.28096 12.2829ZM8.24289 14.5143V14.2202C7.69174 14.4158 7.10947 14.5143 6.50004 14.5143C5.89061 14.5143 5.30833 14.4158 4.75718 14.2201V14.5143C4.75718 15.4769 5.53748 16.2572 6.50003 16.2572C7.46259 16.2572 8.24289 15.4769 8.24289 14.5143Z"
		/>
	),
})
export const MessageIcon = createIcon({
	displayName: "MessageIcon",
	viewBox: "0 0 15 15",
	path: (
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 14.8532L7.5651 12H13.5C14.3284 12 15 11.3284 15 10.5V1.5C15 0.671573 14.3284 0 13.5 0H1.5C0.671573 0 0 0.671573 0 1.5V10.5C0 11.3284 0.671573 12 1.5 12H3V14.8532ZM7.1349 10.5L4.5 12.1468V10.5H1.5V1.5H13.5V10.5H7.1349Z"
		/>
	),
})
export const ShareIcon = createIcon({
	displayName: "ShareIcon",
	viewBox: "0 0 15 15",
	path: (
		<path
			d="M9 3C9 3.21556 9.02274 3.42582 9.06594 3.6285L5.2627 5.53012C4.71272 4.89891 3.90295 4.5 3 4.5C1.34315 4.5 0 5.84315 0 7.5C0 9.15685 1.34315 10.5 3 10.5C3.90295 10.5 4.71272 10.1011 5.2627 9.46988L9.06594 11.3715C9.02274 11.5742 9 11.7844 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C11.097 9 10.2873 9.39892 9.73729 10.0301L5.93406 8.12851C5.97726 7.92583 6 7.71557 6 7.5C6 7.28443 5.97726 7.07417 5.93406 6.87149L9.73729 4.96987C10.2873 5.60108 11.097 6 12 6C13.6569 6 15 4.65685 15 3C15 1.34315 13.6569 0 12 0C10.3431 0 9 1.34315 9 3ZM4.5 7.5C4.5 8.32843 3.82843 9 3 9C2.17157 9 1.5 8.32843 1.5 7.5C1.5 6.67157 2.17157 6 3 6C3.82843 6 4.5 6.67157 4.5 7.5ZM12 4.5C12.8284 4.5 13.5 3.82843 13.5 3C13.5 2.17157 12.8284 1.5 12 1.5C11.1716 1.5 10.5 2.17157 10.5 3C10.5 3.82843 11.1716 4.5 12 4.5ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const WhiteArrowIcon = createIcon({
	displayName: "WhiteArrowIcon",
	viewBox: "0 0 20 18",
	path: (
		<path
			d="M15.8419 10.0336H0V7.96636H15.8419L9.00706 1.46179L10.5431 0L20 9L10.5431 18L9.00706 16.5382L15.8419 10.0336Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const SearchIcon = createIcon({
	displayName: "SearchIcon",
	viewBox: "0 0 15 15",
	path: (
		<path
			d="M6.08917 12.1783C2.72622 12.1783 0 9.45213 0 6.08917C0 2.72622 2.72622 0 6.08917 0C9.45213 0 12.1783 2.72622 12.1783 6.08917C12.1783 7.49632 11.701 8.79198 10.8995 9.82309L15 13.9235L13.9235 15L9.82309 10.8995C8.79198 11.701 7.49632 12.1783 6.08917 12.1783ZM10.6561 6.08917C10.6561 8.61139 8.61139 10.6561 6.08917 10.6561C3.56696 10.6561 1.52229 8.61139 1.52229 6.08917C1.52229 3.56696 3.56696 1.52229 6.08917 1.52229C8.61139 1.52229 10.6561 3.56696 10.6561 6.08917Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const CorrectIcon = createIcon({
	displayName: "CorrectIcon",
	viewBox: "0 0 18 14",
	path: (
		<path
			d="M6.25847 10.1907L16.4492 0L18 1.55084L6.25847 13.2924L0 7.0339L1.55084 5.48305L6.25847 10.1907Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const LeftArrow = createIcon({
	displayName: "LeftArrow",
	viewBox: "0 0 20 18",
	path: (
		<path
			fill="currentColor"
			d="M4.15812 7.96636L20 7.96636L20 10.0336L4.15812 10.0336L10.9929 16.5382L9.45694 18L7.86805e-07 9L9.45694 -9.21703e-07L10.9929 1.46178L4.15812 7.96636Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const RightArrow = createIcon({
	displayName: "RightArrow",
	viewBox: "0 0 20 18",
	path: (
		<path
			d="M15.8419 10.0336H0V7.96636H15.8419L9.00706 1.46179L10.5431 0L20 9L10.5431 18L9.00706 16.5382L15.8419 10.0336Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const ReloadIcon = createIcon({
	displayName: "ReloadIcon",
	viewBox: "0 0 20 20",
	path: (
		<path
			d="M4.19306 5H8V7H1V0H3V3.27035C4.72511 1.18251 7.19577 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10H2C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C7.60638 2 5.55354 3.0787 4.19306 5Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const AttentionIcon = createIcon({
	displayName: "AttentionIcon",
	viewBox: "0 0 22 20",
	path: (
		<path
			d="M21.4424 13.9532L14.4371 1.97762C13.7338 0.758398 12.4229 0.00166216 11.0053 2.73545e-06C9.58755 -0.00165687 8.27626 0.751956 7.56422 1.97767L0.55628 13.9576C-0.170394 15.1795 -0.186834 16.7105 0.517031 17.9592C1.22148 19.2089 2.54051 19.9866 3.97525 19.9983L18.0131 19.9983C19.4628 19.9842 20.7793 19.2089 21.4836 17.9603C22.1871 16.7132 22.1714 15.1856 21.4424 13.9532ZM2.27894 14.9737L9.29206 2.98491C9.64723 2.37354 10.2986 1.99918 11.003 2C11.7073 2.00083 12.3584 2.37673 12.7077 2.98222L19.7186 14.9672C20.086 15.5885 20.0939 16.3533 19.7417 16.9777C19.389 17.603 18.7295 17.9913 18.0034 17.9984L3.98339 17.9983C3.27278 17.9925 2.61208 17.6029 2.25929 16.9771C1.90689 16.3519 1.91512 15.5855 2.27894 14.9737ZM11.0012 15.9983C11.5537 15.9983 12.0015 15.5506 12.0015 14.9983C12.0015 14.4461 11.5537 13.9983 11.0012 13.9983C10.4487 13.9983 10.0009 14.4461 10.0009 14.9983C10.0009 15.5506 10.4487 15.9983 11.0012 15.9983ZM12.0045 5.99835H10.0038V12.9983H12.0045V5.99835Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const PlusIcon = createIcon({
	displayName: "PlusIcon",
	viewBox: "0 0 14 14",
	path: <path d="M7.7 6.3H14V7.7H7.7V14H6.3V7.7H0V6.3H6.3V0H7.7V6.3Z" fillRule="evenodd" clipRule="evenodd" />,
})
// export const UploadIcon = createIcon({
// 	displayName: "UploadIcon",
// 	viewBox: "0 0 13 15",
// 	path: (
// 		<path
// 			d="M8.46424 0H1.36364C0.610521 0 0 0.610521 0 1.36364V13.6364C0 14.3895 0.610521 15 1.36364 15H10.9091C11.6622 15 12.2727 14.3895 12.2727 13.6364V3.80849L8.46424 0ZM1.36335 1.36387H6.81832V4.09077C6.81832 4.84388 7.42885 5.4544 8.18196 5.4544H10.9088V13.6366H1.36335V1.36387ZM8.18196 4.09077V1.64672L10.626 4.09077H8.18196ZM6.81814 11.5911V8.46443L7.69966 9.34595L8.66389 8.38172L6.13632 5.85414L3.60875 8.38172L4.57298 9.34595L5.4545 8.46443V11.5911H6.81814Z"
// 			fillRule="evenodd"
// 			clipRule="evenodd"
// 		/>
// 	),
// })
export const LogOutIcon = createIcon({
	displayName: "LogOutIcon",
	viewBox: "0 0 14 14",
	path: (
		<path
			d="M14 9.05882L8.4 14L7.07467 12.8306L10.4253 9.88235H0V0H1.86667V8.23529H10.4253L7.07467 5.28706L8.4 4.11765L14 9.05882Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const ShowPasswordIcon = createIcon({
	displayName: "ShowPasswordIcon",
	viewBox: "0 0 60 60",
	path: (
		<path
			d="M30 12C13.7018 12 1.16137 28.065 1.16137 28.065L0 29.5L1.16137 30.935C1.16137 30.935 12.5952 45.5212 27.8004 46.8644C28.5258 46.965 29.2512 47 30 47C30.7488 47 31.4742 46.965 32.1996 46.8622C47.4048 45.5213 58.8386 30.9372 58.8386 30.9372L60 29.5L58.8386 28.065C58.8386 28.065 46.2982 12 30 12ZM30 16.375C34.3072 16.375 38.2782 17.6919 41.731 19.4506C42.9764 21.7584 43.6861 24.4162 43.6861 27.3125C43.6944 31.0833 42.4579 34.7247 40.2139 37.5381C37.9699 40.3516 34.8765 42.1389 31.527 42.5572C31.4879 42.5659 31.4429 42.5484 31.4058 42.5572C30.9385 42.5812 30.4731 42.625 30 42.625C29.4799 42.625 28.9775 42.59 28.473 42.5572C25.1235 42.1389 22.0301 40.3516 19.7861 37.5381C17.5421 34.7247 16.3056 31.0833 16.3139 27.3125C16.3139 24.4578 17.0021 21.8 18.2084 19.5184H18.1478C21.626 17.7247 25.6459 16.375 30 16.375ZM30 20.75C28.4439 20.7506 26.9517 21.4428 25.8517 22.6743C24.7517 23.9058 24.134 25.5758 24.1345 27.3169C24.135 29.0579 24.7537 30.7275 25.8544 31.9582C26.9552 33.1889 28.4478 33.88 30.0039 33.8794C30.7744 33.8791 31.5374 33.709 32.2491 33.3788C32.9609 33.0487 33.6076 32.5649 34.1522 31.9551C34.6969 31.3453 35.1289 30.6214 35.4235 29.8249C35.7181 29.0283 35.8697 28.1746 35.8694 27.3125C35.8691 26.4504 35.7171 25.5968 35.422 24.8005C35.1269 24.0041 34.6945 23.2806 34.1495 22.6712C33.6045 22.0618 32.9575 21.5785 32.2455 21.2489C31.5336 20.9192 30.7705 20.7497 30 20.75V20.75ZM12.8923 22.8019C12.5745 24.2793 12.4104 25.7929 12.4035 27.3125C12.4035 31.1494 13.3811 34.7391 15.0919 37.7709C11.6211 35.4961 8.43622 32.7147 5.62109 29.5C7.8372 26.9986 10.2733 24.7538 12.8923 22.7997V22.8019ZM47.1077 22.8019C49.7266 24.7553 52.1627 26.9993 54.3789 29.5C51.5638 32.7147 48.3789 35.4961 44.9081 37.7709C46.6717 34.6401 47.604 31.0132 47.5965 27.3125C47.5965 25.7484 47.4127 24.2544 47.1077 22.7997V22.8019Z"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})
export const HidePasswordIcon = createIcon({
	displayName: "ShowPasswordIcon",
	viewBox: "0 0 60 60",
	path: (
		<path
			d="M5.98866 0L3.17518 3.14685L15.3363 16.6746L37.0269 40.9352L40.7534 45.1733L54.0113 60L56.8229 56.8575L44.6637 43.2598C52.9419 38.6719 58.4945 31.8643 58.8386 31.4357L60 30.0011L58.8386 28.5665C58.3107 27.9083 45.8094 12.5065 30 12.5065C26.1737 12.5065 22.5606 13.4468 19.2466 14.8311L5.98866 0ZM30 16.8801C34.2075 16.8801 38.1882 18.2032 41.731 20.0248C43.0022 22.3749 43.6781 25.0675 43.6861 27.8143C43.685 31.6384 42.3981 35.3221 40.0808 38.1339L34.5223 31.9146C35.3376 30.7949 35.8655 29.3778 35.8655 27.8143C35.8655 26.0743 35.2475 24.4056 34.1475 23.1753C33.0475 21.945 31.5556 21.2538 30 21.2538C28.6021 21.2538 27.3351 21.8442 26.3341 22.7583L22.3631 18.3147C24.7914 17.4771 27.3351 16.8801 30 16.8801ZM11.7916 18.8614C5.52138 23.176 1.45073 28.1991 1.16137 28.5665L0 30.0011L1.16137 31.4357C1.6658 32.0698 13.2443 46.2405 28.168 47.3601C28.7702 47.4257 29.3802 47.4957 30 47.4957C30.6178 47.4957 31.2298 47.4279 31.8339 47.3579C33.4174 47.2494 34.9905 46.9986 36.5381 46.6079L33.054 42.7109C32.0533 42.9778 31.0287 43.1158 30 43.1221C22.4531 43.1221 16.3139 36.2554 16.3139 27.8143C16.3139 26.6531 16.4507 25.5181 16.6814 24.3963L11.7916 18.8614ZM12.8923 23.3028C12.5728 24.7802 12.4088 26.2943 12.4035 27.8143C12.3955 31.4619 13.3062 35.0383 15.0313 38.1339C11.5337 35.8649 8.29229 33.1344 5.37669 30.0011C7.68804 27.509 10.2044 25.2663 12.8923 23.3028ZM47.1077 23.3028C49.7941 25.2686 52.3103 27.5111 54.6233 30.0011C52.8656 31.8971 49.3913 35.3326 44.9081 38.2017C46.6557 35.0889 47.5871 31.4899 47.5965 27.8143C47.5965 26.2835 47.4205 24.7746 47.1077 23.3028Z"
			fill="#393951"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
	),
})

export const ProfileLevelIcon0 = (props) => (
	<Icon viewBox="0 0 18 22" {...props}>
		<path
			fill={props.color}
			d="M8.55556 0L0 4V10C0 15.55 3.65037 20.74 8.55556 22C13.4607 20.74 17.1111 15.55 17.1111 10V4L8.55556 0ZM15.2099 10C15.2099 14.52 12.377 18.69 8.55556 19.93C4.73407 18.69 1.90123 14.52 1.90123 10V5.3L8.55556 2.19L15.2099 5.3V10Z"
		/>
	</Icon>
)
export const ProfileLevelIcon1 = (props) => (
	<Icon viewBox="0 0 18 22" {...props}>
		<path
			fill={props.color}
			d="M8.77772 0L0.222168 4V10C0.222168 15.55 3.87254 20.74 8.77772 22C13.6829 20.74 17.3333 15.55 17.3333 10V4L8.77772 0ZM15.432 10C15.432 14.52 12.5992 18.69 8.77772 19.93C4.95624 18.69 2.1234 14.52 2.1234 10V5.3L8.77772 2.19L15.432 5.3V10Z"
		/>
		<path d="M4.5 11H13.0556" stroke={props.color} strokeWidth="1.3" />
	</Icon>
)
export const ProfileLevelIcon2 = (props) => (
	<Icon viewBox="0 0 18 22" {...props}>
		<path
			fill={props.color}
			d="M8.99989 0L0.444336 4V10C0.444336 15.55 4.09471 20.74 8.99989 22C13.9051 20.74 17.5554 15.55 17.5554 10V4L8.99989 0ZM15.6542 10C15.6542 14.52 12.8214 18.69 8.99989 19.93C5.17841 18.69 2.34557 14.52 2.34557 10V5.3L8.99989 2.19L15.6542 5.3V10Z"
		/>
		<path d="M4.72217 12.2222H13.2777" stroke={props.color} strokeWidth="1.3" />
		<path d="M4.72217 8.55566H13.2777" stroke={props.color} strokeWidth="1.3" />
	</Icon>
)
export const ProfileLevelIcon3 = (props) => (
	<Icon viewBox="0 0 18 22" {...props}>
		<path
			fill={props.color}
			d="M9.2223 0L0.666748 4V10C0.666748 15.55 4.31712 20.74 9.2223 22C14.1275 20.74 17.7779 15.55 17.7779 10V4L9.2223 0ZM15.8766 10C15.8766 14.52 13.0438 18.69 9.2223 19.93C5.40082 18.69 2.56798 14.52 2.56798 10V5.3L9.2223 2.19L15.8766 5.3V10Z"
		/>
		<path d="M4.94434 11H13.4999" stroke={props.color} strokeWidth="1.3" />
		<path d="M4.94434 14.6667H13.4999" stroke={props.color} strokeWidth="1.3" />
		<path d="M4.94434 7.33325H13.4999" stroke={props.color} strokeWidth="1.3" />
	</Icon>
)
export const ProfileLevelIcon4 = (props) => (
	<Icon viewBox="0 0 18 22" {...props}>
		<path
			fill={props.color}
			d="M9.44447 0L0.888916 4V10C0.888916 15.55 4.53929 20.74 9.44447 22C14.3497 20.74 18 15.55 18 10V4L9.44447 0ZM16.0988 10C16.0988 14.52 13.266 18.69 9.44447 19.93C5.62299 18.69 2.79015 14.52 2.79015 10V5.3L9.44447 2.19L16.0988 5.3V10Z"
		/>
		<path d="M5.16675 9.77783H13.7223" stroke={props.color} strokeWidth="1.3" />
		<path d="M5.16675 12.2222H13.7223" stroke={props.color} strokeWidth="1.3" />
		<path d="M9.44434 6.11108L9.44434 20.7778" stroke={props.color} strokeWidth="1.3" />
		<path d="M5.16675 7.33325H13.7223" stroke={props.color} strokeWidth="1.3" />
	</Icon>
)
export const ProfileLevelIcon5 = (props) => (
	<Icon viewBox="0 0 18 22" {...props}>
		<path
			fill={props.color}
			d="M8.66664 0L0.111084 4V10C0.111084 15.55 3.76145 20.74 8.66664 22C13.5718 20.74 17.2222 15.55 17.2222 10V4L8.66664 0ZM15.321 10C15.321 14.52 12.4881 18.69 8.66664 19.93C4.84516 18.69 2.01232 14.52 2.01232 10V5.3L8.66664 2.19L15.321 5.3V10Z"
		/>
		<path d="M4.11108 9L13.1111 9" stroke={props.color} strokeWidth="1.3" />
		<path d="M4.11108 12L13.1111 12" stroke={props.color} strokeWidth="1.3" />
		<path d="M10.6667 6.11108L10.6667 20.7778" stroke={props.color} strokeWidth="1.3" />
		<path d="M8.11108 6.11108L8.11108 20.7778" stroke={props.color} strokeWidth="1.3" />
		<path d="M4.11108 6L13.1111 6" stroke={props.color} strokeWidth="1.3" />
	</Icon>
)

export const ReportIcon = (props) => (
	<Icon viewBox="0 0 19 19" {...props}>
		<path
			d="M15.8333 1.58334H3.16659C2.29575 1.58334 1.59117 2.29584 1.59117 3.16667L1.58325 17.4167L4.74992 14.25H15.8333C16.7041 14.25 17.4166 13.5375 17.4166 12.6667V3.16667C17.4166 2.29584 16.7041 1.58334 15.8333 1.58334ZM15.8333 12.6667H4.09284L3.62575 13.1338L3.16659 13.5929V3.16667H15.8333V12.6667ZM4.74992 9.5H6.33325V11.0833H4.74992V9.5ZM4.74992 7.125H6.33325V8.70834H4.74992V7.125ZM4.74992 4.75H6.33325V6.33334H4.74992V4.75ZM7.91659 9.5H11.8749V11.0833H7.91659V9.5ZM7.91659 7.125H14.2499V8.70834H7.91659V7.125ZM7.91659 4.75H14.2499V6.33334H7.91659V4.75Z"
			fill={props.color}
		/>
	</Icon>
)

export const LocationIcon = (props) => (
	<Icon viewBox="0 0 20 20" {...props}>
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
			<path stroke="#292D32" strokeWidth="2" d="M10 11.192a2.6 2.6 0 100-5.2 2.6 2.6 0 000 5.2z" />
			<path
				stroke="#292D32"
				strokeWidth="2"
				d="M3.017 7.075C4.658-.142 15.35-.133 16.983 7.083c.959 4.234-1.675 7.817-3.983 10.034a4.328 4.328 0 01-6.008 0c-2.3-2.217-4.934-5.809-3.975-10.042z"
			/>
		</svg>
	</Icon>
)
export const ClockIcon = (props) => (
	<Icon viewBox="0 0 20 20" {...props}>
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.3333 10.0001C18.3333 14.6001 14.6 18.3334 10 18.3334C5.40001 18.3334 1.66667 14.6001 1.66667 10.0001C1.66667 5.40008 5.40001 1.66675 10 1.66675C14.6 1.66675 18.3333 5.40008 18.3333 10.0001Z"
				stroke="#012C31"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8416 9.69167 10.2 9.69167 9.67497V6.2583"
				stroke="#012C31"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)

export const Hourglass = (props) => (
	<Icon viewBox="0 0 19 25" {...props}>
		<svg xmlns="http://www.w3.org/2000/svg" width="19" height="25" fill={props.fill ? props.fill : "mc_black"} viewBox="0 0 19 25">
			<path d="M18.293 2.735c.39 0 .707-.343.707-.765V.764C19 .342 18.683 0 18.293 0H1.373C.984 0 .668.342.668.764V1.97c0 .422.316.764.707.764h.439v19.531h-.44c-.39 0-.706.342-.706.764v1.206c0 .422.316.765.707.765h16.919c.39 0 .707-.343.707-.765V23.03c0-.422-.317-.764-.707-.764h-.439V2.735h.439zM2.576 22.265V2.736h.719c-.186 0-.337.14-.337.312v.937c0 .173.15.311.335.313 0 3.454.552 6.81 4.554 7.967l.198.062c.173.055.38.12.486.174-.106.053-.31.118-.482.172l-.19.06c-4.013 1.161-4.566 4.518-4.566 7.971-.185.002-.334.14-.334.312v.938c0 .172.15.313.336.313h-.719zm12.278-1.953c-.359-3.216-5.02-5.172-5.02-5.172s-4.663 1.956-5.022 5.172H4.06c.064-4.142 1.172-6.008 4.019-6.832l.195-.06c.547-.173 1.064-.337 1.064-.92s-.518-.747-1.068-.92l-.203-.064C5.23 10.696 4.123 8.83 4.06 4.688h11.547c-.063 4.143-1.172 6.01-4.017 6.832l-.19.06c-.55.172-1.07.336-1.07.92 0 .583.517.747 1.065.92l.205.064c2.836.82 3.944 2.686 4.008 6.829h-.754zm2.236 1.954h-.718c.185 0 .336-.14.336-.313v-.938c0-.172-.15-.31-.334-.311 0-3.455-.553-6.812-4.555-7.968l-.2-.064a4.125 4.125 0 01-.483-.172c.106-.053.314-.118.487-.173l.185-.06c4.013-1.16 4.566-4.516 4.566-7.97.184-.001.334-.14.334-.313v-.937c0-.173-.15-.312-.336-.312h.718v19.53"></path>
		</svg>
	</Icon>
)
export const Created = (props) => (
	<Icon viewBox="0 0 22 22" {...props}>
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
			<path
				stroke="#000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M9.795 2.979H3.706A2.706 2.706 0 001 5.685v12.177a2.706 2.706 0 002.706 2.706h13.53a2.706 2.706 0 002.706-2.706v-6.089"
			></path>
			<path
				fillRule="evenodd"
				stroke="#000"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M19.942 1.581a1.978 1.978 0 01-.023 2.774l-9.448 9.448-4.059 1.353 1.353-4.06 9.453-9.532a1.906 1.906 0 012.55-.141l.174.158z"
				clipRule="evenodd"
			></path>
			<path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.236 4.332l1.29 1.353"></path>
		</svg>
	</Icon>
)

export const UploadCVIcon = (props) => (
	<Icon viewBox="0 0 18 18" {...props}>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.98999 4.87496L8.90999 2.95496L10.83 4.87496"
				stroke="#F5FEFF"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.91003 10.6349V3.00745"
				stroke="#F5FEFF"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 9C3 12.315 5.25 15 9 15C12.75 15 15 12.315 15 9"
				stroke="#F5FEFF"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)
export const ArticlesIcon = (props) => (
	<Icon viewBox="0 0 54 54" {...props}>
		<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none" viewBox="0 0 54 54">
			<path
				stroke="#082D4F"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2.5"
				d="M20.25 49.5h13.5C45 49.5 49.5 45 49.5 33.75v-13.5C49.5 9 45 4.5 33.75 4.5h-13.5C9 4.5 4.5 9 4.5 20.25v13.5C4.5 45 9 49.5 20.25 49.5z"
			></path>
			<path
				stroke="#082D4F"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2.5"
				d="M4.5 29.25h8.46a4.5 4.5 0 014.027 2.497l2.003 4.028c1.26 2.475 3.51 2.475 4.05 2.475h7.943a4.5 4.5 0 004.027-2.498l2.003-4.027a4.5 4.5 0 014.027-2.498h8.415"
			></path>
			<path
				stroke="#EC5C5C"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2.5"
				d="M23.265 15.75h7.492M21.375 22.5h11.25"
			></path>
		</svg>
	</Icon>
)
export const EduIcon = (props) => (
	<Icon viewBox="0 0 54 54" {...props}>
		<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.87402 40.5005V15.7505C7.87402 6.75049 10.124 4.50049 19.124 4.50049H34.874C43.874 4.50049 46.124 6.75049 46.124 15.7505V38.2505C46.124 38.5655 46.124 38.8805 46.1015 39.1955"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.2865 33.75H46.124V41.625C46.124 45.9675 42.5915 49.5 38.249 49.5H15.749C11.4065 49.5 7.87402 45.9675 7.87402 41.625V40.1625C7.87402 36.63 10.754 33.75 14.2865 33.75Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M17.999 15.7495H35.999" stroke="#EC5C5C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M17.999 23.625H29.249" stroke="#EC5C5C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	</Icon>
)

export const TopTenIcon = (props) => (
	<Icon viewBox="0 0 54 54" {...props}>
		<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20.249 49.5005H33.749C44.999 49.5005 49.499 45.0005 49.499 33.7505V20.2505C49.499 9.00049 44.999 4.50049 33.749 4.50049H20.249C8.99902 4.50049 4.49902 9.00049 4.49902 20.2505V33.7505C4.49902 45.0005 8.99902 49.5005 20.249 49.5005Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M34.875 41.6245C37.35 41.6245 39.375 39.5995 39.375 37.1245V16.8745C39.375 14.3995 37.35 12.3745 34.875 12.3745C32.4 12.3745 30.375 14.3995 30.375 16.8745V37.1245C30.375 39.5995 32.3775 41.6245 34.875 41.6245Z"
				stroke="#EC5C5C"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19.124 41.6255C21.599 41.6255 23.624 39.6005 23.624 37.1255V29.2505C23.624 26.7755 21.599 24.7505 19.124 24.7505C16.649 24.7505 14.624 26.7755 14.624 29.2505V37.1255C14.624 39.6005 16.6265 41.6255 19.124 41.6255Z"
				stroke="#EC5C5C"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)

export const AchievementsIcon = (props) => (
	<Icon viewBox="0 0 62 62" {...props}>
		<svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M49.0827 23.2503C49.0827 26.9962 47.9719 30.432 46.0602 33.2995C43.2702 37.4329 38.8527 40.352 33.7119 41.1012C32.8335 41.2562 31.9294 41.3337 30.9994 41.3337C30.0693 41.3337 29.1652 41.2562 28.2868 41.1012C23.146 40.352 18.7285 37.4329 15.9385 33.2995C14.0268 30.432 12.916 26.9962 12.916 23.2503C12.916 13.2528 21.0018 5.16699 30.9994 5.16699C40.9969 5.16699 49.0827 13.2528 49.0827 23.2503Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M54.8937 47.7149L50.6312 48.7223C49.6753 48.9548 48.9262 49.6782 48.7195 50.6341L47.8153 54.4316C47.3245 56.4982 44.6895 57.1182 43.3203 55.4907L30.9978 41.334L18.6753 55.5165C17.3062 57.144 14.6712 56.524 14.1803 54.4573L13.2762 50.6598C13.0437 49.704 12.2945 48.9549 11.3645 48.7482L7.10201 47.7407C5.13868 47.2757 4.44118 44.8215 5.86201 43.4007L15.937 33.3257C18.727 37.459 23.1445 40.3782 28.2853 41.1274C29.1637 41.2824 30.0678 41.3599 30.9978 41.3599C31.9278 41.3599 32.832 41.2824 33.7103 41.1274C38.8512 40.3782 43.2687 37.459 46.0587 33.3257L56.1337 43.4007C57.5545 44.7957 56.857 47.2499 54.8937 47.7149Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M32.4981 15.448L34.0223 18.4963C34.2289 18.9097 34.7714 19.323 35.2623 19.4005L38.0264 19.8655C39.7831 20.1497 40.1964 21.4413 38.9306 22.7072L36.7864 24.8513C36.4248 25.213 36.2181 25.9105 36.3473 26.4272L36.9673 29.088C37.4581 31.1805 36.3473 32.0071 34.4873 30.8963L31.9039 29.3721C31.4389 29.088 30.6639 29.088 30.1989 29.3721L27.6156 30.8963C25.7556 31.9813 24.6448 31.1805 25.1356 29.088L25.7556 26.4272C25.8589 25.9363 25.6781 25.213 25.3164 24.8513L23.1723 22.7072C21.9064 21.4413 22.3198 20.1755 24.0764 19.8655L26.8406 19.4005C27.3056 19.323 27.8481 18.9097 28.0548 18.4963L29.5789 15.448C30.3281 13.7947 31.6714 13.7947 32.4981 15.448Z"
				stroke="#EC5C5C"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)
export const FormularIcon = (props) => (
	<Icon viewBox="0 0 28 28" {...props}>
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.33301 2.3335V5.8335"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.667 2.3335V5.8335"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.16699 15.1665H17.5003"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.16699 19.8335H14.0003"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="currentColor"
			/>
			<path
				d="M18.6667 4.0835C22.5517 4.2935 24.5 5.77516 24.5 11.2585V18.4685C24.5 23.2752 23.3333 25.6785 17.5 25.6785H10.5C4.66667 25.6785 3.5 23.2752 3.5 18.4685V11.2585C3.5 5.77516 5.44833 4.30516 9.33333 4.0835H18.6667Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)

export const DocIcon = (props) => (
	<Icon viewBox="0 0 28 28" {...props}>
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.6673 12.833V19.833C25.6673 24.4997 24.5007 25.6663 19.834 25.6663H8.16732C3.50065 25.6663 2.33398 24.4997 2.33398 19.833V8.16634C2.33398 3.49967 3.50065 2.33301 8.16732 2.33301H9.91732C11.6673 2.33301 12.0523 2.84634 12.7173 3.73301L14.4673 6.06634C14.9107 6.64967 15.1673 6.99967 16.334 6.99967H19.834C24.5007 6.99967 25.6673 8.16634 25.6673 12.833Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M9.33398 2.33301H19.834C22.1673 2.33301 23.334 3.49967 23.334 5.83301V7.44301"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)
export const ChangeProfileIcon = (props) => (
	<Icon viewBox="0 0 28 28" {...props}>
		<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.3326 11.4444C11.5599 11.4444 12.5548 10.4495 12.5548 9.22222C12.5548 7.99492 11.5599 7 10.3326 7C9.10527 7 8.11035 7.99492 8.11035 9.22222C8.11035 10.4495 9.10527 11.4444 10.3326 11.4444Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.7779 2.55566H10.3334C4.77789 2.55566 2.55566 4.77789 2.55566 10.3334V17.0001C2.55566 22.5557 4.77789 24.7779 10.3334 24.7779H17.0001C22.5557 24.7779 24.7779 22.5557 24.7779 17.0001V11.4446"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M17.833 5.88867H23.9441" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<path d="M20.8887 8.94461V2.8335" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<path
				d="M3.29883 21.3891L8.77661 17.7113C9.65438 17.1224 10.921 17.1891 11.7099 17.8668L12.0766 18.1891C12.9433 18.9335 14.3433 18.9335 15.2099 18.1891L19.8322 14.2224C20.6988 13.478 22.0988 13.478 22.9655 14.2224L24.7766 15.778"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Icon>
)

export const Logged7daysAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path d="M29.2307 17.74L24.2907 31H21.0507L25.1507 20.2L26.0907 20.54H20.2707V17.74H29.2307Z" fill="#EC5C5C" />
			<circle cx="24" cy="24" r="14.25" stroke="#082D4F" strokeWidth="3.5" />
		</svg>
	</Icon>
)

export const Logged14daysAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				d="M17.0352 17.74H21.0152V31H18.0952V20.54H17.0352V17.74ZM22.1102 28.1V28.08L30.5702 17.58H30.5902V25.9H32.1702V28.1H30.5902V31H27.6702V28.1H22.1102ZM27.8102 23.96L26.2702 26.02L25.9902 25.9H27.6702V23.82L27.8102 23.96Z"
				fill="#EC5C5C"
			/>
			<circle cx="24" cy="24" r="14.25" stroke="#082D4F" strokeWidth="3.5" />
		</svg>
	</Icon>
)

export const LikesAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M35.0009 22.4996C35.0009 20.5648 33.701 19.0497 31.551 19.0497H28.0172L28.0492 18.9626C28.081 18.8764 28.1707 18.64 28.258 18.41L28.2586 18.4085L28.2586 18.4083C28.3361 18.2042 28.4115 18.0054 28.4428 17.9215C28.6614 17.3346 28.821 16.8618 28.9501 16.3935C29.1452 15.6857 29.2511 15.048 29.2511 14.4499C29.2511 12.7571 28.2068 11.7058 26.6617 11.2559C25.9648 11.0529 25.3583 10.9999 24.6513 11H24.0999L23.7546 11.43C23.3646 11.9156 22.5986 12.791 21.7154 13.8002C20.086 15.6621 18.0579 17.9796 17.2571 19.1461C17.0489 19.0841 16.8282 19.0508 16.5998 19.0508H14.2999C13.0297 19.0508 12 20.0805 12 21.3507V31.7003C12 32.9705 13.0297 34.0002 14.2999 34.0002H16.5998C17.3903 34.0002 18.0877 33.6014 18.5017 32.994C18.8509 33.22 19.2405 33.4085 19.664 33.5601C20.6327 33.9067 21.5934 34.0131 22.3909 33.9985L30.4011 33.9992C33.5694 33.9992 35.0009 29.3344 35.0009 22.4996ZM18.9023 21.3492C18.9023 21.073 18.9534 20.8284 19.0653 20.5672C19.2663 20.098 21.0895 18.0179 22.8176 16.0464L22.8176 16.0463L22.8179 16.046C23.7097 15.0286 24.5761 14.0401 25.1811 13.3169C25.4702 13.3386 25.7427 13.383 26.0196 13.4636C26.6786 13.6555 26.9521 13.9309 26.9521 14.4495C26.9521 14.8135 26.8784 15.2571 26.7337 15.7818C26.6256 16.1739 26.4856 16.5888 26.2884 17.1181C26.2605 17.1932 26.1907 17.3771 26.1165 17.5727L26.1164 17.573L26.1161 17.5737C26.0257 17.812 25.9288 18.0674 25.8929 18.1644C25.7434 18.5688 25.6448 18.8665 25.5775 19.137C25.291 20.287 25.5784 21.3492 26.9521 21.3492H31.5519C32.3468 21.3492 32.7018 21.7631 32.7018 22.4992C32.7018 28.0083 31.5693 31.6988 30.4019 31.6988H22.3522L22.3097 31.6995C21.8064 31.7086 21.0995 31.6302 20.4397 31.3942C19.4221 31.0301 18.9023 30.4364 18.9023 29.3989V21.3492ZM14.2988 31.7V21.3511H16.5986V31.7H14.2988Z"
				fill="#EC5C5C"
			/>
		</svg>
	</Icon>
)

export const SeenArticlesAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				d="M34.8346 21.6668V27.5002C34.8346 33.3335 32.668 35.6668 27.2513 35.6668H20.7513C15.3346 35.6668 13.168 33.3335 13.168 27.5002V20.5002C13.168 14.6668 15.3346 12.3335 20.7513 12.3335H26.168"
				stroke="#EC5C5C"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M34.8346 21.6668H30.5013C27.2513 21.6668 26.168 20.5002 26.168 17.0002V12.3335L34.8346 21.6668Z"
				stroke="#EC5C5C"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M18.582 25.1665H25.082" stroke="#EC5C5C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18.582 29.8335H22.9154" stroke="#EC5C5C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	</Icon>
)

export const Finished15EduAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				d="M14.791 26.5003V14.5837C14.791 10.2503 15.8743 9.16699 20.2077 9.16699H27.791C32.1243 9.16699 33.2077 10.2503 33.2077 14.5837V25.417C33.2077 25.5687 33.2077 25.7203 33.1968 25.872"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.8785 23.25H33.2077V27.0417C33.2077 29.1325 31.5068 30.8333 29.416 30.8333H18.5827C16.4918 30.8333 14.791 29.1325 14.791 27.0417V26.3375C14.791 24.6367 16.1777 23.25 17.8785 23.25Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M19.666 14.583H28.3327" stroke="#082D4F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M19.666 18.375H25.0827" stroke="#082D4F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M17.3867 25.74H21.3667V39H18.4467V28.54H17.3867V25.74ZM27.1017 39.16C26.3151 39.16 25.5484 39.0133 24.8017 38.72C24.0551 38.4267 23.4751 38.0733 23.0617 37.66L24.5617 35.34C24.8017 35.6333 25.1417 35.88 25.5817 36.08C26.0351 36.2667 26.4684 36.36 26.8817 36.36C27.1884 36.36 27.4751 36.2933 27.7417 36.16C28.0084 36.0267 28.2217 35.8267 28.3817 35.56C28.5417 35.2933 28.6217 34.9667 28.6217 34.58C28.6217 34.1533 28.5351 33.78 28.3617 33.46C28.2017 33.14 27.9617 32.8933 27.6417 32.72C27.3351 32.5333 26.9684 32.44 26.5417 32.44C26.1284 32.44 25.7351 32.5 25.3617 32.62C24.9884 32.7267 24.5484 32.9133 24.0417 33.18H24.0217V25.74H30.6417V28.54H26.5217V30.68L26.1817 30.08C26.3684 30.0533 26.5484 30.0333 26.7217 30.02C26.8951 30.0067 27.0684 30 27.2417 30C28.1751 30 28.9617 30.2067 29.6017 30.62C30.2551 31.0333 30.7551 31.58 31.1017 32.26C31.4484 32.94 31.6217 33.68 31.6217 34.48C31.6217 35.36 31.4217 36.1533 31.0217 36.86C30.6217 37.5667 30.0751 38.1267 29.3817 38.54C28.7017 38.9533 27.9417 39.16 27.1017 39.16Z"
				fill="#EC5C5C"
			/>
		</svg>
	</Icon>
)

export const Finished20EduAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				d="M14.791 26.5003V14.5837C14.791 10.2503 15.8743 9.16699 20.2077 9.16699H27.791C32.1243 9.16699 33.2077 10.2503 33.2077 14.5837V25.417C33.2077 25.5687 33.2077 25.7203 33.1968 25.872"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.8785 23.25H33.2077V27.0417C33.2077 29.1325 31.5068 30.8333 29.416 30.8333H18.5827C16.4918 30.8333 14.791 29.1325 14.791 27.0417V26.3375C14.791 24.6367 16.1777 23.25 17.8785 23.25Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M19.666 14.583H28.3327" stroke="#082D4F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M19.666 18.375H25.0827" stroke="#082D4F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M13.4706 39C14.2973 38.16 15.0906 37.3533 15.8506 36.58C16.6106 35.7933 17.2906 35.04 17.8906 34.32C18.504 33.5867 18.984 32.88 19.3306 32.2C19.6906 31.52 19.8706 30.86 19.8706 30.22C19.8706 29.94 19.8173 29.6867 19.7106 29.46C19.6173 29.2333 19.4773 29.04 19.2906 28.88C19.1173 28.72 18.904 28.6 18.6506 28.52C18.4106 28.4267 18.1373 28.38 17.8306 28.38C17.524 28.38 17.2506 28.4267 17.0106 28.52C16.7706 28.6 16.5706 28.7133 16.4106 28.86C16.2506 29.0067 16.124 29.1667 16.0306 29.34C15.9506 29.5133 15.9106 29.6933 15.9106 29.88C15.9106 30.3067 15.9773 30.6867 16.1106 31.02C16.2573 31.34 16.4506 31.6267 16.6906 31.88L14.9106 33.5C14.524 33.3133 14.1906 33 13.9106 32.56C13.644 32.12 13.4373 31.66 13.2906 31.18C13.1573 30.6867 13.0906 30.28 13.0906 29.96C13.0906 29.2267 13.2906 28.5267 13.6906 27.86C14.104 27.1933 14.6973 26.6467 15.4706 26.22C16.2573 25.7933 17.2106 25.58 18.3306 25.58C19.2506 25.58 20.0506 25.7867 20.7306 26.2C21.4106 26.6133 21.9373 27.16 22.3106 27.84C22.6973 28.5067 22.8906 29.22 22.8906 29.98C22.8906 30.58 22.7973 31.16 22.6106 31.72C22.424 32.28 22.164 32.8333 21.8306 33.38C21.5106 33.9133 21.144 34.4467 20.7306 34.98C20.3173 35.5 19.8906 36.0333 19.4506 36.58L18.1306 36.2H23.0506V39H13.4706ZM29.3308 39.02C28.5708 39.02 27.8508 38.8867 27.1708 38.62C26.5041 38.3533 25.9108 37.9467 25.3908 37.4C24.8841 36.84 24.4841 36.14 24.1908 35.3C23.8974 34.4467 23.7508 33.4467 23.7508 32.3C23.7508 31.02 23.8908 29.9533 24.1708 29.1C24.4508 28.2333 24.8374 27.54 25.3308 27.02C25.8374 26.5 26.4308 26.1333 27.1108 25.92C27.7908 25.6933 28.5308 25.58 29.3308 25.58C30.0908 25.58 30.8041 25.7133 31.4708 25.98C32.1508 26.2467 32.7441 26.66 33.2508 27.22C33.7708 27.7667 34.1774 28.4667 34.4708 29.32C34.7641 30.16 34.9108 31.1533 34.9108 32.3C34.9108 33.4867 34.7641 34.5067 34.4708 35.36C34.1774 36.2133 33.7708 36.9133 33.2508 37.46C32.7308 37.9933 32.1374 38.3867 31.4708 38.64C30.8041 38.8933 30.0908 39.02 29.3308 39.02ZM29.3108 36.24C29.9774 36.24 30.4974 36.0667 30.8708 35.72C31.2441 35.36 31.5041 34.8733 31.6508 34.26C31.8108 33.6467 31.8908 32.9667 31.8908 32.22C31.8908 31.4867 31.8108 30.8333 31.6508 30.26C31.5041 29.6867 31.2441 29.2333 30.8708 28.9C30.4974 28.5533 29.9774 28.38 29.3108 28.38C28.6574 28.38 28.1441 28.5533 27.7708 28.9C27.3974 29.2467 27.1374 29.7133 26.9908 30.3C26.8441 30.8867 26.7708 31.5467 26.7708 32.28C26.7708 33.0133 26.8441 33.68 26.9908 34.28C27.1374 34.88 27.3974 35.36 27.7708 35.72C28.1441 36.0667 28.6574 36.24 29.3108 36.24Z"
				fill="#EC5C5C"
			/>
		</svg>
	</Icon>
)

export const Finished15TestsAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				d="M24.0434 8L11 14.9565L24.0434 21.9129L37.0867 14.9565L24.0434 8Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.2188 17.7388V23.6518C16.2188 25.5648 19.697 27.9996 24.0448 27.9996C28.3926 27.9996 31.8708 25.5648 31.8708 23.6518V17.7388"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M37.0859 14.9565V26.2608"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.3867 25.74H20.3667V39H17.4467V28.54H16.3867V25.74ZM26.1017 39.16C25.3151 39.16 24.5484 39.0133 23.8017 38.72C23.0551 38.4267 22.4751 38.0733 22.0617 37.66L23.5617 35.34C23.8017 35.6333 24.1417 35.88 24.5817 36.08C25.0351 36.2667 25.4684 36.36 25.8817 36.36C26.1884 36.36 26.4751 36.2933 26.7417 36.16C27.0084 36.0267 27.2217 35.8267 27.3817 35.56C27.5417 35.2933 27.6217 34.9667 27.6217 34.58C27.6217 34.1533 27.5351 33.78 27.3617 33.46C27.2017 33.14 26.9617 32.8933 26.6417 32.72C26.3351 32.5333 25.9684 32.44 25.5417 32.44C25.1284 32.44 24.7351 32.5 24.3617 32.62C23.9884 32.7267 23.5484 32.9133 23.0417 33.18H23.0217V25.74H29.6417V28.54H25.5217V30.68L25.1817 30.08C25.3684 30.0533 25.5484 30.0333 25.7217 30.02C25.8951 30.0067 26.0684 30 26.2417 30C27.1751 30 27.9617 30.2067 28.6017 30.62C29.2551 31.0333 29.7551 31.58 30.1017 32.26C30.4484 32.94 30.6217 33.68 30.6217 34.48C30.6217 35.36 30.4217 36.1533 30.0217 36.86C29.6217 37.5667 29.0751 38.1267 28.3817 38.54C27.7017 38.9533 26.9417 39.16 26.1017 39.16Z"
				fill="#EC5C5C"
			/>
		</svg>
	</Icon>
)

export const PassedTestsAchieveIcon = (props) => (
	<Icon viewBox="0 0 48 48" {...props}>
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="24" cy="24" r="22.25" fill="#F5FEFF" stroke="#082D4F" strokeWidth="3.5" />
			<path
				d="M24.0434 8L11 14.9565L24.0434 21.9129L37.0867 14.9565L24.0434 8Z"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.2188 17.7388V23.6518C16.2188 25.5648 19.697 27.9996 24.0448 27.9996C28.3926 27.9996 31.8708 25.5648 31.8708 23.6518V17.7388"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M37.0859 14.9565V26.2608"
				stroke="#082D4F"
				strokeWidth="2.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.9969 36.7998L35.0184 23L37 25.1001L21.9969 41L14 32.525L15.9816 30.4249L21.9969 36.7998Z"
				fill="#EC5C5C"
			/>
		</svg>
	</Icon>
)

export const downloadIcon = (props) => (
	<Icon viewBox="0 0 19 19" {...props}>
		<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.8294 7.1748C15.5294 7.4073 16.6319 8.7948 16.6319 11.8323V11.9298C16.6319 15.2823 15.2894 16.6248 11.9369 16.6248H7.05437C3.70187 16.6248 2.35938 15.2823 2.35938 11.9298V11.8323C2.35938 8.8173 3.44687 7.4298 6.10187 7.1823"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path d="M9.5 2V11.66" stroke="#F5FEFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
			<path
				d="M12.0133 9.9873L9.50078 12.4998L6.98828 9.9873"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</Icon>
)

export const UploadIcon = (props) => (
	<Icon viewBox="0 0 13 15" {...props}>
		<svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				// fill-rule="evenodd"
				// clip-rule="evenodd"
				d="M8.46424 0H1.36364C0.610521 0 0 0.610521 0 1.36364V13.6364C0 14.3895 0.610521 15 1.36364 15H10.9091C11.6622 15 12.2727 14.3895 12.2727 13.6364V3.80849L8.46424 0ZM1.36335 1.36387H6.81832V4.09077C6.81832 4.84388 7.42885 5.4544 8.18196 5.4544H10.9088V13.6366H1.36335V1.36387ZM8.18196 4.09077V1.64672L10.626 4.09077H8.18196ZM6.81814 11.5911V8.46443L7.69966 9.34595L8.66389 8.38172L6.13632 5.85414L3.60875 8.38172L4.57298 9.34595L5.4545 8.46443V11.5911H6.81814Z"
				fill="#F5FEFF"
			/>
		</svg>
	</Icon>
)

export const LockerIcon = (props) => (
	<Icon fill="none" viewBox="0 0 31 32" {...props}>
		<path
			stroke={"currentColor" || "#F5FEFF"}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M7.75 13.333v-2.667c0-4.413 1.292-8 7.75-8s7.75 3.587 7.75 8v2.667M15.5 24.667c1.783 0 3.23-1.493 3.23-3.334 0-1.84-1.447-3.333-3.23-3.333-1.784 0-3.23 1.492-3.23 3.333 0 1.841 1.447 3.334 3.23 3.334z"
		></path>
		<path
			stroke={"currentColor" || "#F5FEFF"}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M21.958 29.334H9.042c-5.167 0-6.459-1.334-6.459-6.667V20c0-5.333 1.292-6.666 6.459-6.666h12.916c5.167 0 6.459 1.333 6.459 6.666v2.667c0 5.333-1.292 6.666-6.459 6.666z"
		></path>
	</Icon>
)

export const CopyIcon = (props) => (
	<Icon viewBox="0 0 24 24" fill="none" {...props}>
		<path
			fill="currentColor"
			d="M19 21H8V7h11m0-2H8a2 2 0 00-2 2v14a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2m-3-4H4a2 2 0 00-2 2v14h2V3h12V1z"
		></path>
	</Icon>
)
